import { CircleAlert, LoaderCircle, LockKeyhole, SendHorizontal } from "lucide-react";
import { adjustDateTime, getPractice, getSecureData, notify, removeSecureItem, setSecureData } from "../../helpers";
import { useEffect, useState } from "react";
import { fetchAllSupportMessages, handelSupportMessage } from "../../services/Support";
import { useLocation, useParams, Navigate } from "react-router-dom";
import BackBtn from "../Button/BackBtn";
import Spacing from "../Spacing";

export default function SingleSupportMessage(){
    let account_id = getPractice("account_id");
    let location_id =getPractice("location_id");
    const [showDetails, setShowDetails] = useState(false);
    const [messageData, setMessageData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { caseId } = useParams();
    const location = useLocation();
    const { selectedSupport } = location.state || {};
    const [messageFormData, setMessageFormData] = useState({
      account_id: account_id,
      location_id: location_id,
      case_id: parseInt(caseId),
      message: '',
    });
    
    const handleDivInput = (e) => {
      setMessageFormData((prevData) => ({
        ...prevData,
        message: e.target.innerText,
        case_id: caseId
      }));
    };

    const handleSendMessage = async (event) => {
      event.preventDefault();
      if (!messageFormData.message.trim()) {
        notify('error', 'Message cannot be empty');
        return;
      }
      try {
        const response = await handelSupportMessage(messageFormData);
        if (response.data.status === 'error') {
          notify('error', response?.data?.message);
        } else {
          setMessageFormData((prevData) => ({
            ...prevData,
            message: '', 
          }));
          document.querySelector('.docpro_messanger_input').innerText = '';     
          
          await removeSecureItem("support_last_fetch_id");
          await fetchMessages(account_id, location_id, caseId, null);
        }
      } catch (error) {
        notify('error', 'Something went wrong');
      }
    };

    const fetchMessages = async (account_id, location_id, case_id, last_fetch_id = null) => {
      // setIsLoading(true);
      if (!last_fetch_id) {
        last_fetch_id = await getSecureData("support_last_fetch_id");
      }
      if (caseId) {
        try {
          const response = await fetchAllSupportMessages(account_id, location_id, case_id, last_fetch_id);
      
          if (response) {
            let newMessages = response?.data?.messages || [];
            let newFetchId = response?.data?.support_last_fetch_id;
            let currentFetchId = await getSecureData("support_last_fetch_id");
      
            // If `newFetchId` is not undefined, update the stored fetch ID
            if (newFetchId !== undefined && newFetchId !== currentFetchId) {
              await setSecureData("support_last_fetch_id", newFetchId);
              last_fetch_id = newFetchId;
            }
      
            setMessageData(prevMessages => {
              const allMessages = [...prevMessages, ...newMessages];
              // Remove duplicates by filtering unique IDs
              const uniqueMessages = allMessages.filter(
                (msg, index, self) => index === self.findIndex(m => m.id === msg.id)
              );
              return uniqueMessages;
            });
          }
        } catch (error) {
          console.error("Error fetching messages:", error);
        }finally{
          setIsLoading(false);
        }
      }
    };

    useEffect(() => {
      const remove_support_last_fetch_id = async () => { 
        await removeSecureItem("support_last_fetch_id");
      }
      remove_support_last_fetch_id();
      setIsLoading(true);
      fetchMessages(account_id, location_id, caseId, null);
    
      if(caseId){
        const intervalId = setInterval(() => {
          fetchMessages(account_id, location_id, caseId);
  
        }, 3000);
        return () => clearInterval(intervalId);
      }
    }, [account_id,location_id,caseId]); 

    useEffect(() => {
      setMessageFormData(prevFilter => ({
        ...prevFilter,
        account_id: account_id,
        location_id: location_id
      }));
    }, [account_id, location_id]);
    

    if (caseId.length === 9) {
        return (
        <>
        <BackBtn href="/admin/support" btnText="Back to Support" />
        <Spacing lg="0" sm="15" />
        <div className="docpro_support_message_user docpro_card">
            <div className="docpro_support_message_head">
                <div className="docpro_user">
                    <div className="docpro_user_info">
                        <h3 className="docpro_fs_16 docpro_primary_color" style={{display:"flex",whiteSpace: "wrap",overflow: "hidden",textOverflow: "ellipsis", margin:"4px 0px"}}><strong>Subject: </strong> &nbsp;&nbsp;{selectedSupport?.subject}</h3>
                        <div className="ticket_details" style={{ display: showDetails ? "block" : "none", color:"#000" }}>
                          <div className="docpro_grid docpro_grid_gap_50 docpro_grid_col_2">
                            <div className="" style={{width:"100%"}}>
                              {selectedSupport?.feature_type && <p className="docpro_primary_color">
                              <strong>Feature Type:&nbsp;&nbsp;</strong> {selectedSupport?.feature_type}
                              </p>}
                              {selectedSupport?.impact && <p className="docpro_primary_color"><strong>Impact: &nbsp;&nbsp;</strong> {selectedSupport?.impact}</p>}
                            </div>
                            <div className="" style={{width:"100%"}}>
                            {selectedSupport?.cc_mail && <p className="docpro_primary_color"><strong>CC Mail: &nbsp;&nbsp;</strong> {selectedSupport?.cc_mail}</p>}
                            {selectedSupport?.case_id && <p className="docpro_primary_color"><strong>Case ID: &nbsp;&nbsp;</strong> {selectedSupport?.case_id}</p>}
                            </div>
                          </div>
                            {selectedSupport?.issue && <p className="docpro_primary_color" style={{display:"flex",whiteSpace: "wrap",overflow: "hidden",textOverflow: "ellipsis"}}><strong>Issue:&nbsp;&nbsp; </strong> {selectedSupport?.issue}</p>}
                        </div>
                        <button onClick={() => setShowDetails(!showDetails)} style={{background:"none",border:"none",cursor:"pointer",color:"var(--vivid)"}}>{showDetails ? "See Less" : "See More"}</button>
                    </div>
                </div>
            </div>
            <div className="docpro_support_message_body">
            {isLoading ? (
                <div className="flex items-center loading" style={{ width: '100%', height: '100%', minHeight: '120px', justifyContent: 'center', background: 'var(--white)', borderRadius: '12px',alignItems:'center' }}>
                  <span className="docpro_loading" style={{ position: 'inherit' }}>
                    <LoaderCircle width={40} height={40} style={{ color: "#369eff" }} />
                  </span>
                </div>
              ): messageData.length > 0 ? 
                (
                    messageData?.slice().sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).map((msg, index) => (
                    <div
                        key={index}
                        className={`docpro_message_item`}
                        style={{marginTop:"5px"}}
                    >
                        {msg.account_id === account_id & msg.location_id === location_id ? 
                        <div className="right-msg-data text-right" >
                        <div className="shoutbox-flex">
                            <div>
                            <div className='flex'>
                                <div className="flex-grow-2 relative">
                                <p className="mb-0 leading-5" style={{color:"#fff"}}>{msg.message}</p>
                                <span className="docpro_tip">{adjustDateTime(msg.created_at)}</span>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                        : 
                        <div className="left-msg-data" >
                        <div className="shoutbox-flex">
                            {/* <div className="docpro_message_item_avatar  shoutbox_img_avatar">
                            <span className="docpro_tip">{msg.location_name}</span>
                            </div> */}
                            <div>
                            <div className='flex'>
                                <div className="flex-grow-2 relative">
                                <p className="mb-0 leading-5">{msg.message}</p>
                                <span className="docpro_tip">{adjustDateTime(msg.created_at)}</span>
                                </div>

                                <div className='relative'>
                                
                                </div>
                            </div>
                            </div>
                        </div>
                        </div> 
                        }
                        
                    </div>
                    ))
                )
                :
                <div style={{display:"flex",justifyContent:"center",alignItems:"center",height: "100vh",textAlign:"center",color:"gray",opacity:"85%"}}>No Messages found</div>
                }
            </div>
            {selectedSupport?.status ? 
                <div className="docpro_messanger_body_bottom">
                    <div className="docpro_messanger_input_wrap">
                        <div
                        className="docpro_messanger_input docpro_fs_16"
                        contentEditable="true"
                        data-placeholder="Replay message..."
                        role="textbox"
                        aria-multiline="true"
                        suppressContentEditableWarning={true}
                        autoComplete="off"
                        onInput={handleDivInput}
                        ></div>
                        <button
                        className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn"
                        onClick={handleSendMessage}
                        >
                        <SendHorizontal width={20} height={20} />
                        Send
                        </button>
                    </div>
                </div>
                : 
                <div style={{textAlign:"center",padding:"8px",color:"#000",borderRadius:"0px 0px 14px 0px"}}>This ticket is closed <LockKeyhole size={"15"} /></div>
            }
        </div>
        </>
        )
    }else{
        return <Navigate to="/admin/support" replace  />
    }
}